/**
 * @Description 客流计数 - 任务详情抽屉主体内容
 */

import { FC, useEffect, useMemo, useState } from 'react';
import styles from './index.module.less';
// import V2LineChart from '@/common/components/Charts/V2LineChart';
import { useMethods } from '@lhb/hook';
import { beautifyThePrice, getKeysFromObjectArray, isNotEmptyAny } from '@lhb/func';
import V2Tabs from '@/common/components/Data/V2Tabs';
import V2Title from '@/common/components/Feedback/V2Title';
import V2DetailGroup from '@/common/components/Feedback/V2DetailItem/Group';
import { Col, Row } from 'antd';
import V2DetailItem from '@/common/components/Feedback/V2DetailItem';
import V2PieChart from '@/common/components/Charts/V2PieChart';
import MachineInfo from './MachineInfo';
import { AnaStatus } from '../../ts-config';
import dayjs from 'dayjs';
import { deviceTaskAnalysisDetail, deviceTaskAnalysisDetailDemo } from '@/common/api/passengerflowcount';
import IconFont from '@/common/components/IconFont';
import SpotLines from './SpotLines';

const SpotDetailDrawerMain: FC<{
  spotDetail, isDemonstrate
}> = ({ spotDetail, isDemonstrate }) => {
  // const [xAxisDataLine, setXAxisDataLine] = useState<Array<string>>([]);
  // const [seriesDataLine, setSeriesDataLine] = useState<any>({});
  const [tabItems, setTabItems] = useState<any>([]);
  const [tabActive, setTabActive] = useState<string>('');
  const [sexPieChartData, setSexPieChartData] = useState<any>([]);
  const [agePieChartData, setAgePieChartData] = useState<any>([]);
  const [taskAnalysisDetail, setTaskAnalysisDetail] = useState<any>({}); // 任务分析详情

  const imgArr:{url:string}[] = useMemo(() => {
    if (taskAnalysisDetail?.cameraList && taskAnalysisDetail.cameraList?.length) {
      return getKeysFromObjectArray(taskAnalysisDetail.cameraList, 'picUrl').filter(itm => !!itm).map((item: any) => ({ url: item }));
    }
    return [];
  }, [taskAnalysisDetail?.cameraList]);

  useEffect(() => {
    if (isNotEmptyAny(spotDetail)) {
      methods.getTabItems();
    }
  }, [spotDetail]);

  useEffect(() => {
    tabActive && methods.getDeviceTaskAnalysisDetail(tabActive);
  }, [tabActive]);

  const methods = useMethods({
    // getLineChartData() {
    //   if (taskAnalysisDetail.lineChart?.length) {
    //     const xAxisData: any = [];
    //     const data: any = [];
    //     taskAnalysisDetail.lineChart.forEach((res) => {
    //       xAxisData.push(res.name);
    //       data.push(Number(res.value));
    //     });
    //     setXAxisDataLine(xAxisData);
    //     setSeriesDataLine({
    //       name: taskAnalysisDetail.date,
    //       unit: '人',
    //       data
    //     });
    //   }
    // },
    getTabItems() {
      if (spotDetail.tasks) {
        const _tabItems = spotDetail.tasks.map(item => {
          return {
            label: `${dayjs(item.date).format('YYYY.MM.DD')}(${methods.getDateFormat(item.date)})`,
            key: item.id,
          };
        });
        setTabItems(_tabItems);
        setTabActive(_tabItems?.[0].key);
      }
    },
    getPieChartData() {
      const sexPieData = [
        { value: taskAnalysisDetail.passbyMale, name: '男' },
        { value: taskAnalysisDetail.passbyFemale, name: '女' }
      ];
      const agePieData = [
        { value: taskAnalysisDetail.passbyChild, name: '儿童' },
        { value: taskAnalysisDetail.passbyYouth, name: '青年' },
        { value: taskAnalysisDetail.passbyMiddle, name: '中年' },
        { value: taskAnalysisDetail.passbyOlder, name: '老年' },
      ];
      setSexPieChartData(sexPieData);
      setAgePieChartData(agePieData);
    },
    dateShow() {
      if (taskAnalysisDetail.duration) {
        const minute = Math.floor(taskAnalysisDetail.duration / 60);
        if (minute > 60) {
          return `${Math.floor(minute / 60)}小时${minute % 60}分钟`;
        } else {
          return `${minute}分钟`;
        }
      } else {
        return '-';
      }
    },
    getDateFormat(date) {
      const daysOfWeek = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
      const dayOfWeek = new Date(date).getDay();
      return daysOfWeek[dayOfWeek];
    },
    getDeviceTaskAnalysisDetail(id) {
      const api = isDemonstrate ? deviceTaskAnalysisDetailDemo : deviceTaskAnalysisDetail;
      api(id).then((res) => {
        setTaskAnalysisDetail({ ...res.data || {} });
        // methods.getLineChartData();
        methods.getPieChartData();
      });
    },
    onRefresh() {
      tabActive && methods.getDeviceTaskAnalysisDetail(tabActive);
    }
  });

  return (
    <div className={styles.mainContainer}>
      {/* { taskAnalysisDetail.duration >= 21600 && taskAnalysisDetail.anaStatus === 3 && (
        <div className={styles.timeChartsWrap}>
          <V2LineChart
            title=''
            xAxisData={xAxisDataLine}
            seriesData={[seriesDataLine]}
          />
        </div>
      ) } */}
      <SpotLines id={spotDetail?.id}/>
      <div className={styles.dateBasicInfo}>
        <V2Tabs items={tabItems} activeKey={tabActive} onChange={(val) => {
          setTabActive(val);
        }} />
        <div className={styles.basicContent}>
          <V2Title divider type='H2' text='基本信息' className='mt-16'/>
          <V2DetailGroup>
            <Row gutter={16}>
              <Col span={12}>
                <V2DetailItem label='任务状态' value={ taskAnalysisDetail.anaStatusName } />
              </Col>
              <Col span={12}>
                <V2DetailItem label='设备ID' value={ taskAnalysisDetail.serialNums ? taskAnalysisDetail.serialNums?.join('、') : '-' }/>
              </Col>
              <Col span={12}>
                <V2DetailItem label='拍摄时间' value={ `${taskAnalysisDetail.start}-${taskAnalysisDetail.end}` }/>
              </Col>
              <Col span={12}>
                <V2DetailItem label='拍摄时长' value={ taskAnalysisDetail.duration ? methods.dateShow() : '-' } />
              </Col>
              <Col span={12}>
                <V2DetailItem label='分析时段' value={ taskAnalysisDetail.analysisPeriod } />
              </Col>
              <Col span={12}>
                <V2DetailItem label={
                  <div className={styles.picUrl}>
                    <div>分析区域</div>
                    {!taskAnalysisDetail.hasDrawFrame && <div className={styles.picUrlTips}> <IconFont iconHref='pc-common-icon-ic_warning'/>请尽快绘制分析区域，以免影响正常分析</div>}
                  </div>
                }type='images' assets={ imgArr} />
              </Col>
            </Row>
          </V2DetailGroup>
          {/* 已分析展示 */}
          {taskAnalysisDetail?.anaStatus === AnaStatus.ANALYSIS_COMPLETED && <>
            <V2Title divider type='H2' text='客流统计' className='mt-24' />
            <div className={styles.flowTotalCount}>
              <div className={styles.flowTotalCountLabel}>过店总人数</div>
              <div className={styles.flowTotalCountValue}>{ taskAnalysisDetail.anaStatus === 3 ? <><span>{ beautifyThePrice(taskAnalysisDetail.passbyCount, ',', 0) }</span>人</> : '-' }</div>
              <img className={styles.flowTotalCountIcon} src='https://staticres.linhuiba.com/project-custom/locationpc/flow/flow_icon@2x.png' />
            </div>
            <Row gutter={16} className={styles.sexAgePieChartWrap}>
              { taskAnalysisDetail.passbyGender && (
                <Col span={12}>
                  <div className={styles.pieChartLabel}>性别分布</div>
                  <div className={styles.sexPieChart}>
                    <V2PieChart
                      type='circle'
                      seriesData={[{
                        data: sexPieChartData,
                        unit: '人',
                      }]}
                    />
                  </div>
                </Col>
              ) }
              { taskAnalysisDetail.passbyAge && (
                <Col span={12}>
                  <div className={styles.pieChartLabel}>年龄分布</div>
                  <div className={styles.sexPieChart}>
                    <V2PieChart
                      type='circle'
                      seriesData={[{
                        data: agePieChartData,
                        unit: '人',
                      }]}
                    />
                  </div>
                </Col>
              ) }
            </Row>
          </>}
          { isNotEmptyAny(taskAnalysisDetail) && <MachineInfo
            detail={taskAnalysisDetail}
            isDemonstrate={isDemonstrate}
            onRefresh={methods.onRefresh}/> }
        </div>
      </div>
    </div>
  );
};

export default SpotDetailDrawerMain;
